import Yup from 'src/yup';
import config from 'src/config';

export const validations = Yup.object().shape({
  hostId: Yup.string().required('Required'),
  prefix: Yup.string()
    .required('Required')
    .max(config.env.app.hostPrefixMaxLength, `Must be ${config.env.app.hostPrefixMaxLength} or less characters.`),
});
